import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const RootStyled = styled('section')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 10,
});

export const DropzoneStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: 48,
  border: `1px dashed ${theme.palette.global.gray}`,
  borderRadius: 5,
  padding: 25,
  backgroundColor: '#ecf5fe',
  '&:hover': {
    backgroundColor: '#bbd0e5',
    cursor: 'pointer',
  },
}));

export const DropzoneTitle = styled(Typography)({
  color: '#1A1A1A',
  textAlign: 'center',
  fontSize: '1rem',
  marginBottom: '10px',
});

export const DropzoneSubtitle = styled(Typography)({
  color: '#8D8D8D',
  textAlign: 'center',
  fontSize: '0.85rem',
});
